import { useQuery } from '@tanstack/react-query';
import { graphql } from '../gql/gql';
import { graphqlRequest, shouldRetryQuery } from '../utils/graphqlClient';
import { TripBenefitsQuery } from '../gql/graphql';

const tripBenefits = graphql(/* GraphQL */ `
  query tripBenefits($tripId: Int!) {
    tripBenefits(tripId: $tripId) {
      benefitId
      benefitName
      benefitValue
      isInclusion
    }
  }
`);

const useGetTripBenefits = (tripId: number, shouldFetch?: boolean) => {
  const { data, isLoading } = useQuery<TripBenefitsQuery>({
    queryKey: ['tripBenefits', tripId],
    queryFn: async () =>
      graphqlRequest<TripBenefitsQuery>(tripBenefits, {
        tripId,
      }), // Public endpoint, no auth needed
    enabled: shouldFetch,
    staleTime: 3600000,
    retry: shouldRetryQuery,
  });

  return {
    tripBenefits: data,
    tripBenefitsLoading: isLoading,
  };
};

export default useGetTripBenefits;
